import { css } from '@emotion/react';

import { Pane } from 'screens/booker/components/Box';
import { Header } from 'screens/booker/components/Header';
import { Heading } from 'screens/booker/components/Heading';
import { Tab } from 'screens/booker/components/Tab';
import { OrganizationEmails } from './components/OrganizationEmails';
import { OrganizationPrimaryEmailForm } from './components/OrganizationPrimaryEmailForm';
import { theme } from 'styles/theme';

export const SettingsScreen = () => {
	return (
		<Pane>
			<Header>
				<Heading
					left={
						<>
							<h1
								css={css`
									font-size: 24px;
									line-height: 36px;
									font-weight: normal;
									margin-bottom: 0;
								`}
							>
								Nastavení
							</h1>
						</>
					}
				/>

				<div
					css={css`
						display: flex;
						gap: 24px;
					`}
				>
					<div
						css={css`
							display: flex;
							justify-content: space-between;
							width: 100%;
						`}
					>
						<div
							css={css`
								display: flex;
								gap: 24px;
								align-items: center;
							`}
						>
							<Tab horizontal to="#" active={true}>
								E-maily
							</Tab>
						</div>
					</div>
				</div>
			</Header>

			<Pane
				css={css`
					padding: 30px;
					padding-top: 24px;
					width: 720px;
				`}
			>
				{/* <pre
					css={css`
						font-size: 11px;
						line-height: 16px;
					`}
				>
					{!fetching && JSON.stringify(data, null, 2)}
				</pre> */}

				<h2
					css={css`
						font-size: 16px;
						line-height: 24px;
						font-weight: normal;
						margin-bottom: 0;
					`}
				>
					Primární
				</h2>

				<div
					css={css`
						font-size: 13px;
						line-height: 20px;
						margin-bottom: 12px;
						color: ${theme.color.text[300]};
					`}
				>
					Na tento email se posílá potvrzení vyplnění poptávky.
				</div>

				<OrganizationPrimaryEmailForm />

				<h2
					css={css`
						font-size: 16px;
						line-height: 24px;
						font-weight: normal;

						margin-top: 32px;
						margin-bottom: 0;
					`}
				>
					Notifikace
				</h2>

				<div
					css={css`
						font-size: 13px;
						line-height: 20px;
						margin-bottom: 12px;
						color: ${theme.color.text[300]};
					`}
				>
					Notifikační emaily slouží k zasílání kopií/skrytých kopií, které jsou odesílány ze systému
					poptávajícím, či potvrzovacích emailů.
				</div>

				<OrganizationEmails />
			</Pane>
		</Pane>
	);
};
